<template>
  <div class="set box" :class="{'filtered': set.filter}" ref="box">
    <div class="img" :style="{'background-image':'url('+set.set_img_url+')'}"></div>
    <div class="progress" :style="{width:set.completeness*100+'%'}"></div>

    <div class="topleft">{{set.found}}/{{set.quantity}}</div>
    <div class="bottom">{{set.id}} {{set.name}}</div>
    <ui-ripple-ink trigger=".box"></ui-ripple-ink>
    <ui-progress-circular color="multi-color" v-show="set.name=='Loading'" class="loading" />
  </div>
</template>



<script>
export default {
  name: "set-box",
  props: {
    set: Object
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.set.box {
  height: 150px;
}

.set.filtered {
  opacity: 50%;
}

.set .target {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.set .loading {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.set .img {
  position: absolute;
  top: 1.5em;
  bottom: 1.5em;
}

.set .menu {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 20;
}

.set .topleft {
  position: absolute;
  top: 5px;
  left: 5px;
  height: 1em;
}

.set .bottom {
  position: absolute;
  bottom: 5px;
  left: 5px;
  right: 5px;
  height: 1em;
  overflow: hidden;
}

.set .progress {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.3;
  background: #2196f3;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/set-box.vue